import { renderRatingStars } from './rating';

export function RateDialog($el: JQuery) {
    if ($el) {
        $el.removeClass('hidden');
        $el.dialog({
            closeOnEscape: true,
            width: 'auto',
            modal: true,
            draggable: false,
            resizable: false,
            dialogClass: 'fixed',
            create: function () {
                const ratingEl = $el.find('.rate-stars')[0];
                if (ratingEl) {
                    renderRatingStars(ratingEl, {
                        onSet: function () {
                            var $errorMessageRegion = $el.find(
                                '.error-message'
                            );
                            if ($errorMessageRegion) {
                                $errorMessageRegion.text('');
                            }
                        },
                    });
                }
            },
        });
    }
}
